// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import './utils/axios'
import './utils/vue-init'
import './utils/update.js'
import '@/assets/app.css';

Vue.config.productionTip = false

Vue.config.errorHandler = function (err, vm, info) {
  // Do stuff with error
  console.log(err)
  console.log(vm)
  console.log(info)
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js